
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/apparel/jumpsuits-and-overalls",
      function () {
        return require("private-next-pages/apparel/jumpsuits-and-overalls/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/apparel/jumpsuits-and-overalls"])
      });
    }
  